/* eslint-disable */
import { getObjConfig } from '@webapp-next/lib/session';

/**
 * @param{HTMLAnchorElement} _link
 * @return{String}
 */
export function tmplNavWithMenu(_link = document.createElement('a')) {
  const link = _link.jquery ? _link[0] || document.createElement('a') : _link;

  return `
      <ul class="dropdown-menu dropdown-menu-right">
          <li>
              <a href="${link.getAttribute('href') || ''}"><span class="di-dashboard mr5"></span>${link.text} Dashboard</a>
          </li>
          <li class="divider"></li>
      </ul>
    `;
}

export function dockAppInMenu(vwApp) {
  const $menu = window.$('#dp-main-nav-enterprise');

  if (!$menu) {
    // dockAppInMenu not found for: vwApp, $menu
    return;
  }

  let $link = $menu.find('a:first').eq(0);

  if (!$menu.children('ul').length) {
    // no menu exists
    $link.attr('data-toggle', 'dropdown').addClass('dropdown-toggle');
    $link
      .find('span')
      .html($link.find('span').text() + '<b class="caret"></b>');
    $menu.append(tmplNavWithMenu($link));
  }

  $menu.children('ul').append(vwApp.render().el);
}

export function tabHighlight(strSelectedHref) {
  const liTabArray = $('#pnlNavBar').find('li.navbar-tab');
  const aTabArray = liTabArray.find('a');
  const divPaneArray = $('#deputec_index').children('div.container-pane'); // $('body').find('div.container-pane');

  let elem = $('#container-' + strSelectedHref);

  // Hide apps and breadcrumb
  if (strSelectedHref !== 'location') {
    // hide app if not in reports
    if (strSelectedHref !== 'report') {
      $('#workplace-application-wrapper').hide();
    }

    if (window.$dtbc) {
      window.$dtbc.reset();
    } else {
      setTimeout(() => $dtbc.reset(), 1000);
    }
  }

  // don't double highlight
  if (elem.is(':visible')) {
    return;
  }

  let aSelectedTab = aTabArray.filter('[href^="#' + strSelectedHref + '"]');

  if (!aSelectedTab.length && !elem) {
    return;
  }

  liTabArray.removeClass('active').removeClass('open');
  divPaneArray.hide();
  aSelectedTab.parents('li:first').addClass('active');
  elem.show().trigger('dp-desktop-shown');
  $dt.vwDesktopContent.fixNavToggleHelperLabel();

  if (strSelectedHref === 'newsfeed' || strSelectedHref === 'tasks') {
    const config = getObjConfig();
    if (
      config?.IsMobileBrowser &&
      config?.CanSubmitSupport &&
      !config?.IsMobileToDesktopModalShown
    ) {
      if (__APP__.EMBED.hasAccess('newsfeed', 'mobile-app-modal', true)) {
        $dt.vwModalMobileToDesktop.showMe();
      }
    }
  }
  $dt.strCurrentTab = strSelectedHref;
}

export function showSideTeamStatusBar(blnShow, strSelectedHref, pnlScroll) {
  if (strSelectedHref) {
    // allow certain page can toggle side status bar
    let elem = $('#container-' + strSelectedHref);
    if (blnShow) {
      elem.removeClass('primary-expand');
      elem.children('.js-side-bar-toggle').removeClass('u-flipX');
    } else {
      elem.addClass('primary-expand');
      elem.children('.js-side-bar-toggle').addClass('u-flipX');
    }
  }
  if (blnShow) {
    $('#teamStatusSidebar').show();
  } else {
    $('#teamStatusSidebar').hide();
  }
  if (pnlScroll) {
    // allow certain page can toggle side status bar scroll within itself
    $('#teamStatusSidebar').addClass('scroll');
  } else {
    $('#teamStatusSidebar').removeClass('scroll');
  }
}

export function clearAllTooltip() {
  $('input').tooltip('destroy');
}

export function unDockAppInMenu(vwApp) {
  let $menu = findMyMenu(vwApp);
  if (!$menu) {
    // unDockAppInMenu not found for: vwApp, $menu
    return;
  }
  vwApp.$el.remove();
  let $link = $menu.find('a:first').eq(0);
  if ($menu.children('ul').find('li').length <= 1) {
    // only the dashboard menu?
    $link.attr('data-toggle', '').removeClass('dropdown-toggle');
    $link.find('b.caret').remove();
    $menu.children('ul').remove();
  }
}

export function findMyMenu(vwApp) {
  let $menusCapableOfHoldingChildren = $('#dp-main-nav').find(
    '.js-nav-with-children'
  );
  if (!$menusCapableOfHoldingChildren.length) {
    return null;
  }
  let strURLPrefix = vwApp.appKey.substr(
    0,
    vwApp.appKey.indexOf('/') > -1
      ? vwApp.appKey.indexOf('/')
      : vwApp.appKey.length
  );
  if (strURLPrefix.indexOf('enterprise_team') > -1) {
    strURLPrefix = 'team';
  } // magic override for team
  let $matching = null;
  $menusCapableOfHoldingChildren.each(function () {
    let $this = $(this); // TODO: replace this with the correct vwApp.view
    if ($this.find('a').attr('href').substr(1) == strURLPrefix) {
      $matching = $this;
    }
  });
  return $matching;
}

export function linkRunner(linkHolder) {
  // Given a desktop linkobject , run it
  if (!linkHolder.length) {
    return;
  }
  let url = linkHolder.data('url');
  let name = linkHolder.data('name');

  if (!name) {
    name = linkHolder.text();
  }

  linkLauncher(url, name, linkHolder.prop('hash'));
}

export function focusApp(app) {
  if (app.appURL.match(/#\/?integrations\/(directory|advanced)/)) {
    $dt.rtrMain.navigate(app.appURL, { trigger: true });
  } else {
    // hide all others
    Object.keys($dt.arrAppList).forEach(key => {
      const vapp = $dt.arrAppList[key];

      if (vapp && vapp.hide instanceof Function) {
        vapp.hide.call(vapp);
      }
    });

    const childApp =
      $dt.arrAppList[
        Object.keys($dt.arrAppList).find(
          key =>
            $dt.arrAppList[key].objParent &&
            $dt.arrAppList[key].objParent.cid === app.cid
        )
      ];

    if (childApp) {
      focusApp(childApp);
      return;
    }

    $dt.objCurrentApp = this;
    app.$holder.show();
    app.$iFrame.show().trigger('focus');
    app.checkWin();

    if (app.$iFrame.length && app.$iFrame.get(0).contentWindow) {
      app.$iFrame.get(0).contentWindow.focus();
    }

    $(app.el).addClass('focus');
    $dt.updateScrollPosition(null);

    if (app.win && app.win.DP) {
      app.trackHeight();
    }

    // set height
    if (app.height < $dt.intAppSpaceHeight) {
      app.setHeight($dt.intAppSpaceHeight);
    } else if (app.win.DP) {
      app.win.DP.utils.setDesktopAppHeight.call(app.win.DP.utils); // ask the app
    }

    if (app.blnFirstFocusDone) {
      // call window rostered after first time
      if (app.win?.WindowRestored instanceof Function) {
        app.win.WindowRestored.call(app.win);
      }
    }
  }
}

export function linkLauncher(url, name, key, app, holder, event) {
  const appId = url
    ? Object.keys(window.$dt.arrAppList).find(
        key => window.$dt.arrAppList[key].appURL === url
      )
    : undefined;

  // TODO: do we really need this?
  if (appId) {
    // if it's there show it
    setTimeout(() => {
      focusApp(window.$dt.arrAppList[appId]);
    }, 200);

    if (typeof window.$dt.resizeViewport === 'function') {
      const resizeViewport = window.$dt.resizeViewport;
      if (
        resizeViewport.mock &&
        typeof resizeViewport.mockClear === 'function'
      ) {
        resizeViewport.mockClear();
      }
      resizeViewport();
    }

    return true;
  }

  if (!holder) {
    holder = window.$('#workplace-application-wrapper');
  }

  if (!app || app.appURL !== url) {
    if (app) {
      // kill the current app
      app.closeApp();
    }

    app = new window.$dt.vwDefApp();

    if (holder) {
      app.setHolder(holder);
    }
  }

  app.appURL = url;
  app.appName = name;
  app.appKey = key ? key.replace('#', '') : '';
  app.launch(event);

  if (holder) {
    holder.show();
  }

  window.$dt.resizeViewport();
  return app;
}

export function notyTabletUser() {
  if (getObjConfig()?.IsTablet) {
    DP.utils.notyError(
      _sp(
        'Roster is not optimised for this device and some features may not work well.'
      ),
      true
    );
  }
}

// TODO: new function used on NOMONO bypass
export function hideModules() {
  const jquery = window.$;

  if (!jquery) {
    return;
  }

  jquery('.container-pane').removeClass('active').removeClass('open').hide();

  jquery('.navbar-tab').removeClass('active').removeClass('open');

  if (typeof DP?.endControlLoading === 'function') {
    DP.endControlLoading(jquery('body'));
  }
}
